// extracted by mini-css-extract-plugin
export var alignLeft = "w_qh d_fp d_bG d_dv";
export var alignCenter = "w_bP d_fq d_bD d_dw";
export var alignRight = "w_qj d_fr d_bH d_dx";
export var menuContainer = "w_r1 d_dW";
export var menuContainerFull = "w_r2 d_dT";
export var menuMainHeader = "w_jC d_jC d_w d_c3";
export var menuComponentWrapper = "w_jG d_jG d_cv";
export var menuComponentWrapperDesign2 = "w_jH d_jH d_cy";
export var menuComponentText = "w_jD d_jD d_cn";
export var menuComponentTextDesign2 = "w_jF d_jF d_cs";
export var menuImageWrapperDesign2 = "w_jJ d_jJ d_w d_Z";